// ═══ 인보이스 Submit 핸들러 — useInvoiceState.js 에서 분리 (Phase 2 시동, 2026-05-08) ═══
// 분석 보고서: docs/analysis/use-invoice-state-split-2026-05-08.md
//
// 현 분리 범위: forceSend 만 (state 의존 적음)
// 보류: saveDraft / sendToCustoms — saveInvoiceToDb helper 가 30+ state 결합 → 옵션 A
//       (sub-hook 분해) 진입 시 통합 분리. 본 파일은 시동 + 향후 추가 영역 정착처.
import { API, authFetch } from './api';

// 강제 전송 — 누락 서류 경고 무시하고 send-customs 호출
// deps: { savedInvoiceId, toEmail, setSending, setSent, setSendWarnings, showToast }
export async function forceSend(deps) {
  if (!deps.savedInvoiceId) {
    deps.showToast('인보이스를 먼저 저장하세요', 'err');
    return;
  }
  deps.setSending(true);
  try {
    var resp = await authFetch(API + '/invoices/send-customs', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        invoiceId: deps.savedInvoiceId,
        toEmail: deps.toEmail,
        force: true
      })
    });
    var d = await resp.json();
    deps.setSending(false);
    deps.setSendWarnings([]);
    if (d.success) {
      deps.setSent(true);
      try { sessionStorage.removeItem('autodoc_invoice_temp'); } catch (e) {}
      deps.showToast('✅ 강제 전송 완료! (첨부 ' + d.attachments + '건)');
    } else {
      deps.showToast('실패: ' + (d.error || ''), 'err');
    }
  } catch (err) {
    deps.setSending(false);
    deps.showToast('전송 실패', 'err');
  }
}
